import { Languages } from 'lucide-react';
import { useParams } from 'react-router-dom';

import { HealthCheckList } from '@/components/health/HealthCheckList';
import { HealthRowActions } from '@/components/health/HealthRowActions';
import { useHealthCheck } from '@/hooks/useHealthCheck';

/**
 * Greater-area-scoped Translations health view. Lists every entity that
 * doesn't have a translation in one of the languages already in use in
 * this area.
 */
export function GreaterAreaHealthTranslationsTab() {
  const { id } = useParams<{ id: string }>();
  const { data, isLoading } = useHealthCheck('greaterArea', 'translations', id);

  return (
    <HealthCheckList
      data={data?.data}
      isLoading={isLoading}
      IconAllClear={Languages}
      allClearTitle="Every translation present"
      allClearDescription="Every attraction and theme in this area has translations in every known language."
      emptyTitle="No translations to check"
      emptyDescription="Add at least one translation in any language and gaps for the rest will surface here."
      renderRowActions={(row) => <HealthRowActions row={row} />}
    />
  );
}
